module.exports = __webpack_public_path__ + "img/ImageHover2.0e4340d8.png";